let language = {
    "MY-ACCOUNT-SOCIAL-NETWORK-TIPS": "您目前正在登录我们的网站",

    "MY-ACCOUNT-FORM-EMPTY-TIPS": "不能为空！",
    "MY-ACCOUNT-FORM-SAVE-BUTTON": "保存",

    // user info form
    "MY-ACCOUNT-USER-INFO-CONTAINER-TITLE": "基本信息",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-USER-NAME": "用户名",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-EMAIL": "电子邮箱",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-EMAIL-CHANGE-BUTTON": "修改",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-EMAIL-NEW": "新邮箱",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-EMAIL-NEW-TIPS": "要设置新的电子邮件地址，请按照已发送给我的确认电子邮件中的说明进行操作",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-GENDER": "性别",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-GENDER-MALE": "男性",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-GENDER-FEMALE": "女性",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-GENDER-DIVERSE": "其他性别",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-BIRTH-DATE": "出生日期",

    // password form
    "MY-ACCOUNT-PASSWORD-CONTAINER-TITLE": "密码",
    "MY-ACCOUNT-PASSWORD-FORM-OLD": "旧密码",
    "MY-ACCOUNT-PASSWORD-FORM-NEW": "新密码",

    "MY-ACCOUNT-VERIFICATION-SUCCESS": "邮件验证成功!",
};

export { language }